<template>
  <quick-user-scope
    v-if="lookupProperty.type === propertyType.user"
    :open="open"
    :scope-item="scopeItem"
    :node="node"
    :read-only="readOnly"
    :hide-is-empty="hideIsEmpty"
    :max-tag-text-length="maxTagTextLength"
    :field-name="userScopeConfig.edges.users"
    @update:open="emit('update:open', $event)"
    @update:scope="emit('update:scope', $event)"
    @update:not-operator="emit('update:not-operator', $event)"
    @delete="emit('delete')"
    @add-to-advanced="emit('addToAdvanced')"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
  </quick-user-scope>
  <quick-space-scope
    v-if="lookupProperty.type === propertyType.space"
    :open="open"
    :scope-item="scopeItem"
    :node="node"
    :space-property="lookupProperty"
    :read-only="readOnly"
    :hide-is-empty="hideIsEmpty"
    :max-tag-text-length="maxTagTextLength"
    @update:open="emit('update:open', $event)"
    @update:scope="emit('update:scope', $event)"
    @update:not-operator="emit('update:not-operator', $event)"
    @delete="emit('delete')"
    @add-to-advanced="emit('addToAdvanced')"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
  </quick-space-scope>
  <quick-option-scope
    v-if="[propertyType.options, propertyType.singleSelect].includes(lookupProperty.type)"
    :open="open"
    :scope-item="scopeItem"
    :node="node"
    :options="lookupProperty.options"
    :read-only="readOnly"
    :hide-is-empty="hideIsEmpty"
    :max-tag-text-length="maxTagTextLength"
    @update:open="emit('update:open', $event)"
    @update:scope="emit('update:scope', $event)"
    @update:not-operator="emit('update:not-operator', $event)"
    @delete="emit('delete')"
    @add-to-advanced="emit('addToAdvanced')"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
  </quick-option-scope>
</template>

<script setup>
import QuickOptionScope from '@/components/filter/quick/QuickOptionScope.vue';
import QuickSpaceScope from '@/components/filter/quick/QuickSpaceScope.vue';
import QuickUserScope from '@/components/filter/quick/QuickUserScope.vue';
import useProperties from '@/composables/property/property';
import { computed } from 'vue';
import { propertyType } from 'shared/constants.json';
import { userScope as userScopeConfig } from 'shared/api/query/configs.json';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  scopeItem: {
    type: Object,
    required: true,
  },
  node: {
    type: Object,
    required: true,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  maxTagTextLength: {
    type: Number,
    default: 0,
  },
  hideIsEmpty: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['update:open', 'update:scope', 'update:not-operator', 'delete', 'addToAdvanced']);

const propertySvc = useProperties();
const lookupProperty = computed(() => propertySvc.selectSingle(props.scopeItem.property.lookupProperty.uid));

</script>

<style scoped lang="scss">
</style>
